exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".categoriesSelect .vue-treeselect__control{height:calc(1.5em + .5rem + 2px);padding-top:.25rem;padding-bottom:.25rem;padding-left:.5rem;font-size:.7875rem}.categoriesSelect .vue-treeselect__control .vue-treeselect__placeholder,.categoriesSelect .vue-treeselect__control .vue-treeselect__single-value{line-height:1.5}.transactions-table .transactions-table-style-actions{width:120px}", ""]);

// exports
